// HKDSE 2018 Paper 1 Knowledge Graph Samples - Complete Set Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2018Samples_complete_part2 = {
  word_problems: [
    {
      id: 'hkdse2018_word_problems_01',
      problem: "A shopkeeper bought some oranges at $\\$x$ each and sold them at $\\$y$ each. If he sold all the oranges, he would have a profit of $\\$120$. However, if he sold only $80\\%$ of the oranges, he would have a loss of $\\$40$. Find the number of oranges he bought.",
      problemType: "word_problems_profit_loss",
      difficulty: "intermediate",
      description: "Solving profit and loss problems with percentages",
      graphData: {
        nodes: [
          {
            id: "profit_loss",
            name: "Profit and Loss",
            type: "concepts",
            description: "Understanding profit and loss calculations",
            value: "Profit = Revenue - Cost",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "percentage_sales",
            name: "Percentage Sales",
            type: "concepts",
            description: "Selling only a percentage of goods",
            value: "80% of total oranges sold",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "cost_price",
            name: "Cost Price",
            type: "variables",
            description: "Cost price per orange",
            value: "$x per orange",
            importance: 7,
            x: -200, y: 0, z: 0
          },
          {
            id: "selling_price",
            name: "Selling Price",
            type: "variables",
            description: "Selling price per orange",
            value: "$y per orange",
            importance: 7,
            x: 200, y: 0, z: 0
          },
          {
            id: "total_oranges",
            name: "Total Oranges",
            type: "variables",
            description: "Number of oranges bought",
            value: "n oranges",
            importance: 8,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "profit_loss",
            to: "cost_price",
            type: "depends_on",
            strength: 8
          },
          {
            from: "profit_loss",
            to: "selling_price",
            type: "depends_on",
            strength: 8
          },
          {
            from: "profit_loss",
            to: "total_oranges",
            type: "depends_on",
            strength: 7
          },
          {
            from: "percentage_sales",
            to: "total_oranges",
            type: "depends_on",
            strength: 9
          },
          {
            from: "percentage_sales",
            to: "profit_loss",
            type: "affects",
            strength: 8
          }
        ]
      }
    }
  ],
  geometry: [
    {
      id: 'hkdse2018_geometry_01',
      problem: "In the figure, $ABCD$ is a rectangle. $E$ is a point on $AB$ such that $AE : EB = 2 : 1$. $F$ is a point on $BC$ such that $BF : FC = 1 : 2$. If the area of triangle $DEF$ is $12$ square units, find the area of rectangle $ABCD$.",
      problemType: "geometry_area_ratio",
      difficulty: "intermediate",
      description: "Finding area using ratio and proportion",
      graphData: {
        nodes: [
          {
            id: "rectangle_area",
            name: "Rectangle Area",
            type: "concepts",
            description: "Area of rectangle ABCD",
            value: "Length × Width",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "triangle_area",
            name: "Triangle Area",
            type: "concepts",
            description: "Area of triangle DEF",
            value: "12 square units",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "ratio_division",
            name: "Ratio Division",
            type: "concepts",
            description: "Dividing sides in given ratios",
            value: "AE:EB = 2:1, BF:FC = 1:2",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "coordinate_geometry",
            name: "Coordinate Geometry",
            type: "methods",
            description: "Using coordinates to find areas",
            value: "Area formula with coordinates",
            importance: 7,
            x: 0, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "rectangle_area",
            to: "triangle_area",
            type: "related_to",
            strength: 8
          },
          {
            from: "ratio_division",
            to: "rectangle_area",
            type: "affects",
            strength: 7
          },
          {
            from: "coordinate_geometry",
            to: "triangle_area",
            type: "calculates",
            strength: 9
          },
          {
            from: "ratio_division",
            to: "coordinate_geometry",
            type: "provides_data",
            strength: 8
          }
        ]
      }
    }
  ],
  mensuration: [
    {
      id: 'hkdse2018_mensuration_01',
      problem: "A solid consists of a hemisphere and a cylinder with the same radius. The height of the cylinder is twice the radius. If the total surface area of the solid is $108\\pi$ square units, find the radius of the hemisphere.",
      problemType: "mensuration_surface_area",
      difficulty: "intermediate",
      description: "Calculating surface area of composite solids",
      graphData: {
        nodes: [
          {
            id: "hemisphere_surface",
            name: "Hemisphere Surface",
            type: "concepts",
            description: "Surface area of hemisphere",
            value: "2πr²",
            importance: 9,
            x: -200, y: -200, z: 0
          },
          {
            id: "cylinder_surface",
            name: "Cylinder Surface",
            type: "concepts",
            description: "Surface area of cylinder",
            value: "2πr² + 2πrh",
            importance: 9,
            x: 200, y: -200, z: 0
          },
          {
            id: "radius",
            name: "Radius",
            type: "variables",
            description: "Radius of both hemisphere and cylinder",
            value: "r units",
            importance: 10,
            x: 0, y: 0, z: 0
          },
          {
            id: "height",
            name: "Height",
            type: "variables",
            description: "Height of cylinder",
            value: "2r units",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "total_surface_area",
            name: "Total Surface Area",
            type: "concepts",
            description: "Total surface area of composite solid",
            value: "108π square units",
            importance: 10,
            x: 0, y: -400, z: 0
          }
        ],
        links: [
          {
            from: "hemisphere_surface",
            to: "radius",
            type: "depends_on",
            strength: 9
          },
          {
            from: "cylinder_surface",
            to: "radius",
            type: "depends_on",
            strength: 9
          },
          {
            from: "cylinder_surface",
            to: "height",
            type: "depends_on",
            strength: 8
          },
          {
            from: "total_surface_area",
            to: "hemisphere_surface",
            type: "includes",
            strength: 9
          },
          {
            from: "total_surface_area",
            to: "cylinder_surface",
            type: "includes",
            strength: 9
          }
        ]
      }
    }
  ],
  trigonometry: [
    {
      id: 'hkdse2018_trigonometry_01',
      problem: "In triangle $ABC$, $AB = 8$, $BC = 6$ and $\\angle ABC = 60°$. Find the length of $AC$.",
      problemType: "trigonometry_cosine_law",
      difficulty: "intermediate",
      description: "Using cosine law to find side length",
      graphData: {
        nodes: [
          {
            id: "cosine_law",
            name: "Cosine Law",
            type: "formulas",
            description: "c² = a² + b² - 2ab cos(C)",
            value: "AC² = AB² + BC² - 2(AB)(BC)cos(60°)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "side_ab",
            name: "Side AB",
            type: "variables",
            description: "Length of side AB",
            value: "8 units",
            importance: 8,
            x: -200, y: 0, z: 0
          },
          {
            id: "side_bc",
            name: "Side BC",
            type: "variables",
            description: "Length of side BC",
            value: "6 units",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "angle_b",
            name: "Angle B",
            type: "variables",
            description: "Angle at vertex B",
            value: "60°",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "side_ac",
            name: "Side AC",
            type: "variables",
            description: "Length of side AC to be found",
            value: "AC units",
            importance: 10,
            x: 0, y: -400, z: 0
          }
        ],
        links: [
          {
            from: "cosine_law",
            to: "side_ab",
            type: "uses",
            strength: 8
          },
          {
            from: "cosine_law",
            to: "side_bc",
            type: "uses",
            strength: 8
          },
          {
            from: "cosine_law",
            to: "angle_b",
            type: "uses",
            strength: 9
          },
          {
            from: "cosine_law",
            to: "side_ac",
            type: "calculates",
            strength: 10
          }
        ]
      }
    }
  ],
  functions: [
    {
      id: 'hkdse2018_functions_01',
      problem: "The function $f(x) = x^2 + 2x + 1$ is defined for all real numbers $x$. (a) Find the minimum value of $f(x)$. (b) Find the range of $f(x)$.",
      problemType: "functions_quadratic",
      difficulty: "intermediate",
      description: "Finding minimum value and range of quadratic function",
      graphData: {
        nodes: [
          {
            id: "quadratic_function",
            name: "Quadratic Function",
            type: "concepts",
            description: "f(x) = x² + 2x + 1",
            value: "f(x) = x² + 2x + 1",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "completing_square",
            name: "Completing Square",
            type: "methods",
            description: "Method to find vertex form",
            value: "f(x) = (x+1)²",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "minimum_value",
            name: "Minimum Value",
            type: "concepts",
            description: "Minimum value of the function",
            value: "0 (at x = -1)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "range",
            name: "Range",
            type: "concepts",
            description: "Range of the function",
            value: "[0, ∞)",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "vertex",
            name: "Vertex",
            type: "concepts",
            description: "Vertex of the parabola",
            value: "(-1, 0)",
            importance: 8,
            x: 0, y: -400, z: 0
          }
        ],
        links: [
          {
            from: "quadratic_function",
            to: "completing_square",
            type: "transformed_by",
            strength: 9
          },
          {
            from: "completing_square",
            to: "vertex",
            type: "reveals",
            strength: 9
          },
          {
            from: "vertex",
            to: "minimum_value",
            type: "provides",
            strength: 9
          },
          {
            from: "minimum_value",
            to: "range",
            type: "determines",
            strength: 8
          }
        ]
      }
    }
  ],
  statistics_advanced: [
    {
      id: 'hkdse2018_statistics_advanced_01',
      problem: "The mean and standard deviation of a set of data are $15$ and $3$ respectively. If each value in the data set is increased by $2$, find the new mean and standard deviation.",
      problemType: "statistics_transformation",
      difficulty: "intermediate",
      description: "Effect of linear transformation on mean and standard deviation",
      graphData: {
        nodes: [
          {
            id: "original_mean",
            name: "Original Mean",
            type: "variables",
            description: "Original mean of data set",
            value: "15",
            importance: 8,
            x: -200, y: -200, z: 0
          },
          {
            id: "original_sd",
            name: "Original Standard Deviation",
            type: "variables",
            description: "Original standard deviation",
            value: "3",
            importance: 8,
            x: 200, y: -200, z: 0
          },
          {
            id: "transformation",
            name: "Linear Transformation",
            type: "concepts",
            description: "Adding constant to all values",
            value: "x → x + 2",
            importance: 9,
            x: 0, y: 0, z: 0
          },
          {
            id: "new_mean",
            name: "New Mean",
            type: "variables",
            description: "Mean after transformation",
            value: "17",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "new_sd",
            name: "New Standard Deviation",
            type: "variables",
            description: "Standard deviation after transformation",
            value: "3 (unchanged)",
            importance: 8,
            x: 200, y: 200, z: 0
          }
        ],
        links: [
          {
            from: "original_mean",
            to: "transformation",
            type: "affected_by",
            strength: 8
          },
          {
            from: "transformation",
            to: "new_mean",
            type: "results_in",
            strength: 9
          },
          {
            from: "original_sd",
            to: "transformation",
            type: "affected_by",
            strength: 7
          },
          {
            from: "transformation",
            to: "new_sd",
            type: "results_in",
            strength: 7
          }
        ]
      }
    }
  ]
}; 